import { isNotNilOrEmpty } from "client/Misc/utils";
import {
	DOMOutputSpec,
	Node as ProsemirrorNode,
	NodeSpec
} from "prosemirror-model";

export type MentionNodeAttributes = {
	type: string;
	value: string | null;
	label: string;
	isStale: boolean | undefined;
};

export const mention: NodeSpec = {
	group: "inline",
	inline: true,
	attrs: {
		type: {},
		label: {},
		value: { default: null },
		isStale: { default: undefined }
	},
	parseDOM: [
		{
			tag: "mark",
			getAttrs(dom: string | Node): MentionNodeAttributes | false {
				if (!(dom instanceof HTMLElement)) {
					throw new Error("Expected HTMLElement at this point");
				}

				const {
					mention,
					value,
					stale
				} = dom.dataset;

				if (isNotNilOrEmpty(mention)) {
					return {
						type: mention,
						value: value ?? null,
						label: dom.innerText,
						isStale: stale?.toLowerCase() === "true"
					};
				}

				return false;
			},
		}
	],
	toDOM(node: ProsemirrorNode): DOMOutputSpec {
		const {
			type,
			value,
			label,
			isStale
		} = (node.attrs as MentionNodeAttributes);

		return [
			"mark",
			{
				...isStale
					? {
						"data-stale": "true"
					}
					: {}
				,
				"data-mention": type,
				"data-value": value
			},
			label
		];
	}
};